module.exports = __webpack_public_path__ + "static/media/Omar Escoto.47cb7361.jpg";